<template>
  <FiltersDesktop
    v-model:filtersValues="filtersValues"
    class="mt-32 hidden md:block"
    :resetFilters
    :submitFilters
  />
  <FiltersMobile
    v-model:filtersValues="filtersValues"
    class="md:hidden"
    :resetFilters
    :submitFilters
  />
</template>

<script setup lang="ts">
import type { FilterValues } from './Filters.types'
import FiltersDesktop from './components/FiltersDesktop/FiltersDesktop.vue'
import FiltersMobile from './components/FiltersMobile/FiltersMobile.vue'

const filtersValues = defineModel<FilterValues>('filtersValues', {
  required: true,
})

defineProps<{
  resetFilters: () => void
  submitFilters: () => void
}>()
</script>
